module.exports = __webpack_public_path__ + "static/media/3_3.47fb2b13.png";